import { takeEvery, put, call } from 'redux-saga/effects';
import axios from 'axios';
import { API_CALL } from '../actionTypes/sharedActions';

/** function that returns an axios call */
function axiosApi({ method, url, data, params }) {
  return axios.request({
    method,
    url,
    data,
    params,
  });
}

function* api({ payload, successAction, failureAction }) {
  try {
    // data is obtained after axios call is resolved
    let { data } = yield call(axiosApi, payload);
    yield put({ type: successAction, payload: data });
  } catch (error) {
    yield put({ type: failureAction, payload: error.response.data });
    // catch error on a bad axios call
    // alert using an alert library
  }
}

export default function* watchFetchApi() {
  yield takeEvery(API_CALL, api);
}
